import { ASSACCTYPES__MUTATIONS } from "../mutation-types";
import { ASSACCTYPES__ACTIONS } from "../action-types";
import { ASSACCTYPES__API } from "@/_helpers/urls";
import http from "@/_helpers/http";
import toast from "@/services/Notification";

// State
const state = {
  acctypes: [],
  acctypesbook: null,
  groups: [],
  commissionSetup: [],
  total_ib_levels: 0,
  viewrates: null,
};

// Mutations
const mutations = {
  [ASSACCTYPES__MUTATIONS.ASSIGNEDACCTYPES](state, data) {
    state.acctypes = data;
  },
  [ASSACCTYPES__MUTATIONS.ASSIGNEDACCTYPESBOOK](state, data) {
    state.acctypesbook = data;
  },
  [ASSACCTYPES__MUTATIONS.CURRENCYGROUPS](state, data) {
    state.groups = data;
  },
  [ASSACCTYPES__MUTATIONS.COMRATRESTREE](state, data) {
    state.total_ib_levels = data.total_ib_levels;
    state.commissionSetup = data.commissionSetup;
  },
  [ASSACCTYPES__MUTATIONS.VIEWCOMRATRES](state, data) {
    state.viewrates = data;
  },
};

const getters = {};

// Actions
const actions = {
  async [ASSACCTYPES__ACTIONS.ASSIGNEDACCTYPES]({ commit }) {
    try {
      const response = await http().get(ASSACCTYPES__API.ASSIGNEDACCTYPES);
      commit(
        ASSACCTYPES__MUTATIONS.ASSIGNEDACCTYPES,
        response.data.tradingAccountTypes
      );
      commit(ASSACCTYPES__MUTATIONS.ASSIGNEDACCTYPESBOOK, response.data.book);
    } catch (error) {
      console.error("Error fetching:", error);
    }
  },
  async [ASSACCTYPES__ACTIONS.CURRENCYGROUPS]({ commit }) {
    try {
      const response = await http().get(ASSACCTYPES__API.CURRENCYGROUPS);
      commit(
        ASSACCTYPES__MUTATIONS.CURRENCYGROUPS,
        response.data.currency_groups
      );
    } catch (error) {
      console.error("Error fetching:", error);
    }
  },
  async [ASSACCTYPES__ACTIONS.COMRATRESTREE]({ commit }, parameter) {
    try {
      const accountTypeParam =
        parameter?.account_type != null
          ? `account_type=${parameter.account_type}`
          : "";

      const currencyGroupParam =
        parameter?.currency_group != null
          ? `currency_group=${parameter.currency_group}`
          : "";

      const parameterString = [accountTypeParam, currencyGroupParam]
        .filter((param) => param !== "")
        .join("&");

      const response = await http().get(
        ASSACCTYPES__API.COMRATRESTREE +
          (parameterString !== "" ? `?${parameterString}` : "")
      );
      commit(ASSACCTYPES__MUTATIONS.COMRATRESTREE, response.data.data);
    } catch (error) {
      console.error("Error fetching:", error);
      commit(ASSACCTYPES__MUTATIONS.COMRATRESTREE, []);
    }
  },
  async [ASSACCTYPES__ACTIONS.VIEWCOMRATRES]({ commit }, parameter) {
    try {
      const accountTypeParam =
        parameter?.account_type != null
          ? `account_type=${parameter.account_type}`
          : "";

      const currencyGroupParam =
        parameter?.currency_group != null
          ? `currency_group=${parameter.currency_group}`
          : "";

      const parameterString = [accountTypeParam, currencyGroupParam]
        .filter((param) => param !== "")
        .join("&");

      const response = await http().get(
        ASSACCTYPES__API.VIEWCOMRATRES +
          (parameterString !== "" ? `?${parameterString}` : "")
      );

      commit(ASSACCTYPES__MUTATIONS.VIEWCOMRATRES, response.data);
    } catch (error) {
      console.error("Error fetching:", error);
    }
  },
  async [ASSACCTYPES__ACTIONS.UPDATECOMMISSIONRATES](
    { commit, state, dispatch },
    data
  ) {
    try {
      const response = await http().post(ASSACCTYPES__API.UPDATECOMMISSIONRATES,
        {
          total_ib_levels: data.total_ib_levels,
          account_type: data.account_type,
          currency_group: data.currency_group,
          totalCommission: data.totalCommission,
          commissionRates: data.commissionRates,
        }
      );

      dispatch(ASSACCTYPES__MUTATIONS.ASSIGNEDACCTYPES);
      toast.success(response?.data?.message);
      return response;
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || error?.message);
    }
  },
};

export default {
  strict: process.env.NODE_ENV !== "production",
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
